import React, { Component } from 'react';
import Webcam from 'react-webcam'; 
import { QRCode } from "react-qr-svg";


var PhotoWrapper = React.createClass({
  setRef: function(webcam) {
    this.webcam = webcam;
  },
  capture: function() {
    this.myWidget.open();
    this.props.actionSaveField('')
  },
  resnap: function(){
    this.props.actionSaveField('')
    this.myWidget.open();
  },
  componentWillMount: function(){
    var THIS = this;
    this.myWidget = cloudinary.createUploadWidget({
      cloudName: 'dpbqa6ip8', 
      sources: [ 'local', 'camera', 'instagram'],
        language: "ru",
        text: {
            "ru": {
                "translation": {
                    "or": "или",
                    "back": "Назад",
                    "advanced": "Допольнительно",
                    "close": "Закрыть",
                    "no_results": "Нет результатов",
                    "search_placeholder": "Найти файлы",
                    "about_uw": "About the Upload Widget",
                },
                "selection_counter": {
                    "selected": "фото достаточно"
                },
                "menu": {
                    "files": "Камера",
                    "camera": "Камера",
                    
                    "title_uploading_with_counter": "Uploading {{num}} files"
                },
                "actions": {
                    "upload": "Отправить",
                    "clear_all": "Очистить все",
                    "log_out": "Выйти"
                },
                "camera": {
                    "main_title": "Камера",
                    "capture": "Сфотографировать",
                    "cancel": "Отменить",
                    "take_pic": "Сфотографировать и отправить",
                    "explanation": "Убедитесь, что ваша камера подключена и ваш браузер позволяет снимать с камеры. Когда будете готовы, нажмите Сфотографировать.",
                    "camera_error": "Не могу получить доступ к камере",
                    "retry": "Повторить",
                    "file_name": "Camera_{{time}}"
                },
                "local": {
                    "browse": "Выбрать",
                    "main_title": "Загрузить фото",
                    "dd_title_single": "Перетащите фото сюда",
                    "dd_title_multi": "Drag and Drop assets here",
                    "drop_title_single": "Перетащите фото сюда",
                    "drop_title_multiple": "Drop files to upload"
                },
                "instagram": {
                    "main_title": "Instagram",
                    "no_auth_title": "Загрузить фото из Instagram аккаунта",
                    "no_auth_action": "Подключить Instagram",
                    "header_title": "Выши фотографии",
                    "authenticating": "Авторизация..."
                },
                "queue": {
                    "title": "Загрузка",
                    "title_uploading_with_counter": "Загрузка {{num}} фото",
                    "title_uploading": "Загрузка фото",
                    "mini_title": "Загруженно",
                    "mini_title_uploading": "Загружается фото",
                    "show_completed": "Show completed",
                    "retry_failed": "Retry failed",
                    "abort_all": "Abort all",
                    "upload_more": "Upload more",
                    "done": "Завершенно",
                    "mini_upload_count": "{{num}} uploaded",
                    "mini_failed": "{{num}} failed",
                    "statuses": {
                        "uploading": "Загрузка...",
                        "error": "Ошибка",
                        "uploaded": "Завершенно",
                        "aborted": "Отмененно"
                    }
                },
                "crop": {
                    "title": "Crop your image"

                }
            }
        },
        showAdvancedOptions: false,
        showPoweredBy: false,
        autoMinimize: true,
        cropping: false,
        multiple: false,
        defaultSource: "camera",
        styles: {
            palette: {
                window: "#F5F5F5",
                sourceBg: "#FFFFFF",
                windowBorder: "#90a0b3",
                tabIcon: "#0094c7",
                inactiveTabIcon: "#69778A",
                menuIcons: "#0094C7",
                link: "#53ad9d",
                action: "#8F5DA5",
                inProgress: "#0194c7",
                complete: "#53ad9d",
                error: "#c43737",
                textDark: "#000000",
                textLight: "#FFFFFF"
            },
            fonts: {
                default: null,
                "'Poppins', sans-serif": {
                    url: "https://fonts.googleapis.com/css?family=Poppins",
                    active: true
                }
            }
        },
      uploadPreset: 'uzmvpzpz'}, (error, result) => { 
                if (!error && result && result.event === "success") { 
                    THIS.props.actionSaveField(result.info.secure_url)
                    // console.log('Done! Here is the image info: ', result.info.secure_url); 
                }
          }
      );
  },
  render: function(){
    // console.log(this.props.photo); z
    if(typeof this.props.photo != 'undefined' && this.props.photo !== null && this.props.photo.length > 0){
      return(
        <div className="photoWrapper">
          <img src={this.props.photo} className="image" />
          <div className="photoResnap" onClick={this.resnap}></div>

        </div>
      )
    }else{
      return(
        <div className="photoWrapper" style={!this.props.photo ? {background: '#f1f1f1'} : {}}>
          <div className="photoSnap" onClick={this.resnap}></div>
        </div>
      )
      // console.log('alert', this.props.alert, this.props.alertStatus)
      return(
        <div className="photoWrapper">
          <div className="video" style={{width: '100%', overflow: 'hidden'}}>
            <Webcam
              className="video"
              audio={false}
              height={null}
              width={'1024'}
              // height={'768'}
              flip_horiz={true}
              ref={this.setRef}
              screenshotFormat="image/jpeg"
              style={{position: 'relative'}}
            />
          </div>
          <div className="photoSnap" onClick={this.capture}></div>

        </div>
      )
    }
  }
});

var videoLength = 5;
var PhotoWrapper2 = React.createClass({
  setRef: function(webcam) {
    this.webcam = webcam;
  },
  capture: async function() {
    var THIS = this;
    function countTimer(){
      return new Promise(function(resolve){
        setTimeout(()=>{
          THIS.setState({timer: THIS.state.timer - 1})
          resolve(true)
        }, 1000)
      })
    }
    function wait(delayInMS) {
      return new Promise(resolve => setTimeout(resolve, delayInMS));
    }
    function recorder(){
      var mimeTypeUser = '';
      var types = [
        "video/webm\;codecs=h264",
        "video/webm\;codecs=vp8",
        "video/webm\;codecs=daala",
        "video/mp4\;codecs=h264",
        "video/mp4\;codecs=vp8",
        "video/mp4\;codecs=daala",
        "video/3gpp\;codecs=h264",
        "video/3gpp\;codecs=vp8",
        "video/3gpp\;codecs=daala",
        "video/webm",
        "video/mp4",
        "video/ogg",
        "video/3gpp",
        "video/3gpp2"
          ];

      for (var i in types) {
        if(!mimeTypeUser && MediaRecorder.isTypeSupported(types[i])){
          mimeTypeUser = types[i];
        }
      }
      var stream = THIS.webcam.stream;
      let recorder = new MediaRecorder(stream, {mimeType : mimeTypeUser});
      let data = [];
      var lengthInMS = videoLength * 1000;
      recorder.ondataavailable = event => data.push(event.data);
      recorder.start();
      // console.log(recorder.state + " for " + (lengthInMS/1000) + " seconds...");

      let stopped = new Promise((resolve, reject) => {
        recorder.onstop = resolve;
        recorder.onerror = event => reject(event.name);
      });

      let recorded = wait(lengthInMS).then(
        () => recorder.state == "recording" && recorder.stop()
      );

      return Promise.all([
        stopped,
        recorded
      ]).then(() => {
        
        let recordedBlob = new Blob(data, { type: "video/mp4" }); // mimeTypeUser
        var url = URL.createObjectURL(recordedBlob);
        THIS.setState({videoUrl: url});
      });
    }

    if(this.props.video && typeof MediaRecorder != 'undefined'){
      recorder()
      this.setState({start: true})
      for(var item of new Array(videoLength)){
        await countTimer();
      }
      this.setState({start: false})
    }

   // console.log("this.webcam", this.webcam); // log error stream

   if (typeof ImageCapture !== 'undefined') {

    var imageCapture = new ImageCapture(this.webcam.stream.getVideoTracks()[0]);
  
    var audio = new Audio('audio_file.mp3');
    audio.play();
    this.setState({light: true})

    var canvas = document.createElement('canvas');
    var imageBitmap = await imageCapture.grabFrame();
    canvas.width = imageBitmap.width;
    canvas.height = imageBitmap.height;
    canvas.getContext('2d').drawImage(imageBitmap, 0, 0);

    canvas.toBlob(blob => {
      var imageUrl = URL.createObjectURL(blob);
      this.setState({light: false})

      this.unmountCamera()

      if(this.props.video && typeof MediaRecorder != 'undefined'){
        this.props.actionSaveField(imageUrl, {type: 'video', url: this.state.videoUrl})
      }else{
        this.props.actionSaveField(imageUrl)
      }

      
    }, 'image/jpeg');
  }else
  { 
    //console.log("this.webcam", this.webcam); // log error stream fom webcam
    var video = this.webcam.video;
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    var w,h;

    var audio = new Audio('audio_file.mp3');
    audio.play();
    this.setState({light: true})

    
      w = video.videoWidth;
      h = video.videoHeight;
      canvas.width = w;
      canvas.height = h;
      context.fillRect(0,0,w,h);
      context.drawImage(video,0,0,w,h);
      var dataURI = canvas.toDataURL('image/jpeg');

      // console.log(dataURI); 

      this.unmountCamera()
      this.props.actionSaveField(dataURI)
      setTimeout(()=>{this.setState({light: false})}, 10)
     
    
  }


    // var imageBlob = await imageCapture.takePhoto();
    // var imageUrl = URL.createObjectURL(imageBlob);
    
  },
  resnap: function(){
    this.setState({timer: videoLength, start: false})
    this.props.actionSaveField('')
  },
  componentWillMount: function(){
    this.setState({timer: videoLength, sendedLink: false})
  },
  componentWillUnmount(){
    this.unmountCamera()
  },
  unmountCamera(){
    if(this.webcam && this.webcam.stream){
      var traks = this.webcam.stream.getTracks();

      for(var trak of traks){
        trak.stop();
      }
    }
  },
  sendLinkBySms(link){
    this.setState({
      sendedLink: true
    })
    fetch('/api/sendPhotoLinkBySms', {
      method: 'POST',
      body: JSON.stringify({
        link: link,
        unicPhoto: this.props.unicPhoto
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  render: function(){

    if(!this.props.mobile){
      var link = `https://${window.location.host}/photo/${this.props.unicPhoto}`
      return(
        <div className="photoWrapper2">
          <div style={{
            width: '350px',
            margin: '40px auto',
            display: 'block',
            textAlign: 'center',
            marginTop: '-95px'
          }}>Отсканируйте QR-код на телефоне, что-бы продолжить.</div>
          <QRCode
            bgColor="#f1f1f1"
            fgColor="#000000"
            level="Q"
            style={{ width: 350, display: 'block', margin: '0 auto' }}
            value={link}
          />
          {this.state.sendedLink ? (
            <div style={{display: 'block'}}>
              <div style={{textAlign: 'center', display: 'block', marginTop: '20px'}}>Если смс не пришла, введите ссылку вручную:</div>
              <div style={{textAlign: 'center', display: 'block', marginTop: '5px'}}>{link}</div>
            </div>
          ) : (
            <div style={{
              textDecoration: 'underline',
              color: '#8f9bf1',
              margin: '0 auto',
              width: '350px',
              display: 'block',
              textAlign: 'center',
              marginTop: '20px',
              cursor: 'pointer'
            }} onClick={()=>{this.sendLinkBySms(link)}}>Или отправить ссылку на телефон через смс</div>
          )}
          
        </div>
      )
    }

    var styles = {position: 'relative', objectFit: 'fill', width: '100%', height: '100%'};
    if(this.props.video){
      styles.transform = 'scale(-1, 1)';
    }

    if(typeof this.props.photo != 'undefined' && this.props.photo !== null && this.props.photo.length > 0){
      return(
        <div className="photoWrapper">
          <img src={this.props.photo} styles={styles} className="image" />
          <div className="photoResnap" onClick={this.resnap}></div>

        </div>
      )
    }else{
      
      return(
        <div className="photoWrapper">
          <div className="video" style={{width: '100%', height: '100%', overflow: 'hidden'}}>
            <Webcam
              className="video"
              audio={false}
              height={null}
              width={null}
              // width={1024}
              // height={768}
              ref={this.setRef}
              screenshotFormat="image/jpeg"
              style={styles}
              onUserMedia={function(){
                window.webcam = this.webcam;
                // console.log('onUserMedia', this.webcam.stream.getTracks())
                // var track = this.webcam.stream.getTracks()[0]; 
                // console.log('track.getSettings()', track.getSettings()) 
              }.bind(this)}
              videoConstraints={this.props.videoConstraints}
            />
          </div>
          {this.props.video && this.state.start ? (<div className="timer">{this.state.timer}</div>) : null}
          {this.state.light ? (<div className="light"></div>) : null}
          <div className="photoSnap" onClick={this.capture}></div>

        </div>
      )
    }
  }
});

function PhotoContainer(params){

  if(params.name == 'photo'){
    
     return (
      <PhotoWrapper2 {...params} videoConstraints={{
        facingMode: 'user',
        // width: 1080,
        height: 1920 // 1920 || 99999999999
      }} />
    ) 
    // return(
    //   <PhotoWrapper {...params} />

    // )
  }else if(params.name == 'photo2'){
    return(
      <PhotoWrapper2 {...params} videoConstraints={{
        facingMode: 'environment',
        // width: 1080,
        height: 1920 // 1920 || 99999999999
      }} />
    )
  }else if(params.name == 'photo3'){
    return (
      <PhotoWrapper2 {...params} videoConstraints={{
        facingMode: 'user',
        // width: 1080,
        height: 1920,
      }} video={true} />
    )
  }else{
    return(
      <PhotoWrapper {...params} />
    )
  }

}

export default PhotoContainer;



/** WEBPACK FOOTER **
 ** ./assets/apps/AppForm/components/KeyboardWrapper/components/PhotoWrapper/index.jsx
 **/